<template>
  <div class="mt-data-content">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "MtDataContent",
};
</script>


// WEBPACK FOOTER //
// src/components/Mt/MtDataContent/index.vue